import { useMemo } from 'react';

export const useParams = () => {
  return useMemo(() => {
    try {
      // Check if we're in a browser environment
      if (typeof window === 'undefined') {
        return {
          Id: '',
          WorkflowName: '',
          documentapprovalid: '',
          indexId: 0,
          numberIndex: 0,
          HeadApproverName: '',
          HeadApproverRole: '',
        };
      }

      const urlParams = new URLSearchParams(window.location.search);
      const Id = urlParams.get("id");
      
      // Parse the ID if it exists and contains quotes
      let parsedId = Id;
      if (Id && (Id.includes("'") || Id.includes('"'))) {
        try {
          parsedId = Id.replace(/'/g, '"');
          // Try to parse as JSON to validate
          JSON.parse(parsedId);
        } catch (e) {
          console.warn('Failed to parse ID:', Id);
          parsedId = Id;
        }
      }

      return {
        Id: parsedId || '',
        WorkflowName: urlParams.get("Document_Type") || '',
        documentapprovalid: urlParams.get("documentapprovalid") || '',
        indexId: parseInt(urlParams.get("index") || '0'),
        numberIndex: parseInt(urlParams.get("Comments") || '0'),
        HeadApproverName: urlParams.get("Headname") || '',
        HeadApproverRole: urlParams.get("Designation") || '',
      };
    } catch (error) {
      console.error('Error parsing URL params:', error);
      return {
        Id: '',
        WorkflowName: '',
        documentapprovalid: '',
        indexId: 0,
        numberIndex: 0,
        HeadApproverName: '',
        HeadApproverRole: '',
      };
    }
  }, []);
};